/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { ChargeCustomerACHRequest } from '../model/chargeCustomerACHRequest';
import { ChargeCustomerStoredPaymentMethodRequest } from '../model/chargeCustomerStoredPaymentMethodRequest';
import { ChargeResponse } from '../model/chargeResponse';
import { EditPayByBankAccount } from '../model/editPayByBankAccount';
import { PayByBankAccount } from '../model/payByBankAccount';
import { PayByBankAccountAssignRequest } from '../model/payByBankAccountAssignRequest';
import { PlaidInstitutionResponse } from '../model/plaidInstitutionResponse';
import { PlaidLinkResponse } from '../model/plaidLinkResponse';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class PayByBankApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public assignPayByBankObservable: PayByBankAccount | undefined = undefined;

    /**
     * Assign BankAccount as Primary and/or to all memberships.
     * 
     * @param customerId 
* @param accountId 
* @param body 
     */
    @action
    public assignPayByBank(customerId: number, accountId: number, body?: PayByBankAccountAssignRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PayByBankAccount> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling assignPayByBank.');
        }
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling assignPayByBank.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.put<PayByBankAccount>(
            `${this.basePath}/api/paybybank/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(accountId))}/assignments`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.assignPayByBankObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public chargeObservable: ChargeResponse | undefined = undefined;

    /**
     * 
     * 
     * @param body 
     */
    @action
    public charge(body?: ChargeCustomerACHRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/paybybank/charge`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public chargeStoredPaymentMethodObservable: ChargeResponse | undefined = undefined;

    /**
     * Charges credit card for multiple invoices through stored credit card.
     * 
     * @param body 
     */
    @action
    public chargeStoredPaymentMethod(body?: ChargeCustomerStoredPaymentMethodRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/paybybank/storedpaymentmethod`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeStoredPaymentMethodObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public deletePayByBankObservable: any = undefined;

    /**
     * Deletes pay by bank account from user account with provided id.
     * 
     * @param customerId 
* @param accountId 
     */
    @action
    public deletePayByBank(customerId: number, accountId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling deletePayByBank.');
        }
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling deletePayByBank.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.delete<any>(
            `${this.basePath}/api/paybybank/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(accountId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.deletePayByBankObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public featureObservable: any = undefined;

    /**
     * Check if saved pay by bank feature is enabled
     * 
          */
    @action
    public feature(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<any>(
            `${this.basePath}/api/paybybank/feature`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.featureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getInstitutionObservable: PlaidInstitutionResponse | undefined = undefined;

    /**
     * Retrieves institution detail for plaid workflow
     * 
     * @param institutionId 
     */
    @action
    public getInstitution(institutionId: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PlaidInstitutionResponse> {
        if (institutionId === null || institutionId === undefined) {
            throw new Error('Required parameter institutionId was null or undefined when calling getInstitution.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<PlaidInstitutionResponse>(
            `${this.basePath}/api/paybybank/institution/${encodeURIComponent(String(institutionId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getInstitutionObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getLinkTokenObservable: PlaidLinkResponse | undefined = undefined;

    /**
     * Retrieves token link for plaid workflow
     * 
     * @param customerId 
     */
    @action
    public getLinkToken(customerId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PlaidLinkResponse> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling getLinkToken.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<PlaidLinkResponse>(
            `${this.basePath}/api/paybybank/${encodeURIComponent(String(customerId))}/token/link`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getLinkTokenObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public savePayByBankObservable: PayByBankAccount | undefined = undefined;

    /**
     * Save/Edit bank account.
     * 
     * @param customerId 
* @param body 
     */
    @action
    public savePayByBank(customerId: number, body?: EditPayByBankAccount, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PayByBankAccount> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling savePayByBank.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<PayByBankAccount>(
            `${this.basePath}/api/paybybank/${encodeURIComponent(String(customerId))}`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.savePayByBankObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public savedPayByBanksObservable: Array<PayByBankAccount> | undefined = undefined;

    /**
     * Retrieves all saved pay by bank account for logged-in user
     * 
     * @param customerId 
* @param customerReference 
     */
    @action
    public savedPayByBanks(customerId: number, customerReference: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<PayByBankAccount>> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling savedPayByBanks.');
        }
        if (customerReference === null || customerReference === undefined) {
            throw new Error('Required parameter customerReference was null or undefined when calling savedPayByBanks.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<PayByBankAccount>>(
            `${this.basePath}/api/paybybank/${encodeURIComponent(String(customerId))}/reference/${encodeURIComponent(String(customerReference))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.savedPayByBanksObservable = response.data);
            }
            return response;
        });
    }

}
